export default __webpack_public_path__ + "static/media/rnr-sports-table-19.f2e2ce1b.webp";